import React from 'react';
import styled from 'styled-components';
import { FjWizard } from 'components/primitives';
import type { FjWizardProps } from 'components/primitives/fj-wizard';

import Modal from './modal';

const WizardModalHeader = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.h4};
`;

const WizardModal = styled(Modal).attrs({
  titleWrapper: WizardModalHeader,
})`
  font-size: ${({ theme }) => theme.fontSizes.h5};
`;

type WizardProps = Omit<FjWizardProps, 'modalComponent'>;

const Wizard = (props: WizardProps): React.ReactElement => (
  // WizardModal is a styled-components wrapper whose type does not structurally
  // overlap with `typeof FjModal`; cast through `unknown` per TS guidance.
  <FjWizard
    modalComponent={WizardModal as unknown as FjWizardProps['modalComponent']}
    {...props}
  />
);

export default Wizard;
